import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Navbar from '../../Navbar';
import userImage from '../../../assets/img/user.svg';
import { showToast } from '../../../services';
import { profileActions } from '../../../actions';
import { userActions } from '../../../actions';
import { useLoggedUser } from '../../../hooks/useLoggedUser';

const initialState = {
    selectedAvatar: null,
    submitted: false,
    showModal: false,
    showPurchaseButton: false,
};

const PurchaseAvatar = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [state, setState] = useState(initialState);
    const loggedUser = useLoggedUser();

    if (!loggedUser?.data?.StudentProfileID) {
        history.replace('/login');
        return null;
    }

    const { avatars } = useSelector((state) => state.users);

    useEffect(() => {
        dispatch(userActions.fetchprofileavatars(loggedUser.data.StudentProfileID));
    }, [dispatch]);

    const handleAvatarClick = (avatarId) => {
        setState((prevState) => ({
            ...prevState,
            selectedAvatar: avatarId,
            showPurchaseButton: true, // Show the purchase button when an avatar is selected
        }));
    };

    const purchaseAvatar = (avatarId, coincount) => {
        dispatch(profileActions.purchaseProfileAvatar({
            StudentProfileID: loggedUser.data.StudentProfileID,
            ProfileAvatarID: avatarId,
            PaidCoinCount: coincount
        })).then((response) => {
            if (response?.responseMessage === "You dont have enough coins to purchase this Profile Avatar") {
                showToast(response.responseMessage, 'warn');
                return;
            }
            dispatch(userActions.fetchprofileavatars(loggedUser.data.StudentProfileID));
            dispatch(profileActions.fetchMypoints(loggedUser.data.StudentProfileID));
            handleUpdateAvatar(avatarId); // Call the updateProfileAvatar function after purchase
            setState(prevState => ({ ...prevState, showPurchaseButton: false }));
        }).catch((error) => {
            showToast(error, 'error');
        });
    };

    const handleUpdateAvatar = (avatarId) => {
        dispatch(profileActions.updateProfileAvatar({
            StudentProfileID: loggedUser.data.StudentProfileID,
            AvatarID: avatarId
        })).then((response) => {
            showToast(response.responseMessage, 'success');
            dispatch(profileActions.fetchMyprofile(loggedUser.data.StudentProfileID));
            setState(prevState => ({ ...prevState, selectedAvatar: null, submitted: true }));
        }).catch((error) => {
            showToast(error, 'error');
        });
    };

    return (
        <React.Fragment>
            <div className="continer-fluid profile-page">
                <Navbar />
                <div className="content" id="content">
                    <div className="d-flex justify-content-center align-items-center flex-row">
                        <div className="row avatar-p-row w-80">
                            <div className="row avatar-p-row avatar-shop ">

                                {avatars === undefined ? null : avatars.length > 0 ? (
                                    avatars
                                        .filter(avatar => avatar.AvatarType === "paid" && avatar.is_Purchased !== "Y") // Filter only paid and not purchased avatars
                                        .map((avatar, index) => (
                                            <div key={avatar.ProfileAvatarID ?? avatar.MediaID ?? `avatar-${index}`} className="col-md-3 col-lg-3 col-sm-3 mb-3 text-center">
                                                <div className='d-flex justify-content-center align-items-center flex-column'>
                                                    {avatar.Media_URL ? (
                                                        <img
                                                            className={`avatar-img ${state.selectedAvatar === avatar.MediaID ? 'selected-avatar' : ''}`}
                                                            src={avatar.Media_URL}
                                                            alt="Avatar"
                                                            loading="lazy"
                                                            onClick={() => handleAvatarClick(avatar.MediaID)}
                                                        />
                                                    ) : (
                                                        <div>Image not available</div>
                                                    )}
                                                    <label className="avatar-text align-items-center text-center fw-7 w-100">
                                                        {avatar.CoinCount} coins
                                                    </label>
                                                </div>
                                            </div>
                                        ))
                                ) : (
                                    <p>Avatars not available</p>
                                )}
                            </div>
                            <div className='col-10 ml-10 mt-3 d-flex align-items-center justify-content-center'>
                                {state.showPurchaseButton && (
                                    <button
                                        type="button"
                                        className="accept-btn mt-2 w-60"
                                        onClick={() => purchaseAvatar(
                                            state.selectedAvatar,
                                            avatars.find(a => a.MediaID === state.selectedAvatar)?.CoinCount
                                        )}
                                    >
                                        Purchase
                                    </button>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PurchaseAvatar;